import { render, staticRenderFns } from "./top.vue?vue&type=template&id=6b23e210&scoped=true&"
import script from "./top.vue?vue&type=script&lang=js&"
export * from "./top.vue?vue&type=script&lang=js&"
import style0 from "./top.vue?vue&type=style&index=0&id=6b23e210&prod&lang=less&scoped=true&"
import style1 from "./top.vue?vue&type=style&index=1&id=6b23e210&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b23e210",
  null
  
)

export default component.exports